import { z } from "zod";

export const nodeSettingsSchema = z.object({
    nodeName: z
        .string({
            message: "Node name is required",
        })
        .min(1, {
            message: "Node name is required",
        })
        .min(3, {
            message: "Node name must be at least 3 characters long",
        })
        .max(16, {
            message: "Node name must be at most 16 characters long",
        }),
    defaultServerDirectory: z
        .string({
            message: "Default save location is required",
        })
        .min(1, {
            message: "Server save location is required",
        }),
    serverBackupsDirectory: z
        .string({
            message: "Server backup directory is required",
        })
        .min(1, {
            message: "Server save location is required",
        }),
    manageFirewallAutomatically: z.boolean({
        message: "Manage firewall automatically is required",
    }),
    enableAutoUpdate: z.boolean({
        message: "Enable auto update is required",
    }),
});
